import type { ReferralQualification } from "./referral-schemas";
import { responseSecondsRemaining } from "../../../api/response-time";

export function referralQualificationCurrent(value: ReferralQualification): boolean {
  return value.qualificationSource !== "TEST_WALLET_OVERRIDE" ||
    !!value.testOverride && responseSecondsRemaining(value, value.testOverride.expiresAt) > 0;
}
